//export class RequisitionPartialWorkflowBlade extends MfBladeComponent {
  //protected detailComponents: Array<IDetailComponent> = [ { index: 0, displayName: "Properties", component: RequisitionPartialWorkflowGeneratedForm}];
//};

//export class RequisitionPartialWorkflowListBlade extends MfBladeComponent {
 // protected detailComponents: Array<IDetailComponent> = [ { index: 0, displayName: "Properties", component: RequisitionPartialWorkflowListPageComponent, isMenuHidden: true }];
//};

import { IDataEndPoint, IEntityEndPoints, IFieldOptions, IFormOptions, IGridOptions, IColumnOptions, IEntityOptions } from '@framework/interfaces/IEntity';
import * as app from '@framework/app';
import * as models from '@common/domain/models/RequisitionPartialWorkflowDTO';
import { IApiServiceCommand } from '@services/api/api.service';
export class RequisitionPartialWorkflowEndPoints implements IEntityEndPoints {
	list?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionPartialWorkflow"}, method: "GET" };
	get?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionPartialWorkflow/" + serviceCommand.context.entityId}, method: "GET" };
	update?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionPartialWorkflow/update/" + serviceCommand.context.entityId}, method: "POST" };
	search?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionPartialWorkflow/lazy/"}, method: "POST" };
	pagingTotalCount?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionPartialWorkflow/lazyCount/"}, method: "POST" };
	insert?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionPartialWorkflow/create"}, method: "POST" };
	delete?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionPartialWorkflow/delete/"+ serviceCommand.context.entityId}, method: "POST" };
}

export class RequisitionPartialWorkflowFormFields extends Array<IFieldOptions> {
	public id: IFieldOptions = { field: "id" };
	public requisitionPartialId: IFieldOptions = { field: "requisitionPartialId" };
	public workflowId: IFieldOptions = { field: "workflowId" };
	public datestamp: IFieldOptions = { field: "datestamp" };
	public userId: IFieldOptions = { field: "userId" };
	public comments: IFieldOptions = { field: "comments" };
	constructor() {
		super();
		this.push(this.id);
		this.push(this.requisitionPartialId);
		this.push(this.workflowId);
		this.push(this.datestamp);
		this.push(this.userId);
		this.push(this.comments);
	}
}

export class RequisitionPartialWorkflowForm implements IFormOptions {
	protected requisitionPartialWorkflowFormName: string = "requisitionPartialWorkflowForm";
	protected requisitionPartialWorkflowFormModel: models.RequisitionPartialWorkflowDTO = new models.RequisitionPartialWorkflowDTO();
	protected requisitionPartialWorkflowFormEndPoints: RequisitionPartialWorkflowEndPoints = new RequisitionPartialWorkflowEndPoints();
	protected requisitionPartialWorkflowFormFields: RequisitionPartialWorkflowFormFields = new RequisitionPartialWorkflowFormFields();
	public get name(): string { return this.requisitionPartialWorkflowFormName };
	public get model(): models.RequisitionPartialWorkflowDTO { return this.requisitionPartialWorkflowFormModel };
	public get endPoints(): IEntityEndPoints { return this.requisitionPartialWorkflowFormEndPoints };
       public set endPoints(requisitionPartialWorkflowEndPoints: IEntityEndPoints) {
		this.requisitionPartialWorkflowFormEndPoints = requisitionPartialWorkflowEndPoints;
	};
	public get dataEndPoint(): IDataEndPoint { return this.endPoints.get };
	public get fields(): RequisitionPartialWorkflowFormFields { return this.requisitionPartialWorkflowFormFields };
}

export class RequisitionPartialWorkflowListColumns extends Array<IColumnOptions> {
	public id: IColumnOptions = { field: "id" };
	public requisitionPartialId: IColumnOptions = { field: "requisitionPartialId" };
	public workflowId: IColumnOptions = { field: "workflowId" };
	public datestamp: IColumnOptions = { field: "datestamp", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public userId: IColumnOptions = { field: "userId" };
	public comments: IColumnOptions = { field: "comments" };
	constructor() {
		super();
		this.push(this.id);
		this.push(this.requisitionPartialId);
		this.push(this.workflowId);
		this.push(this.datestamp);
		this.push(this.userId);
		this.push(this.comments);
	}
}

export class RequisitionPartialWorkflowList implements IGridOptions {
	protected requisitionPartialWorkflowListName: string = "requisitionPartialWorkflowList";
	protected requisitionPartialWorkflowListModel: models.RequisitionPartialWorkflowDTO = new models.RequisitionPartialWorkflowDTO();
	protected requisitionPartialWorkflowListEndPoints: RequisitionPartialWorkflowEndPoints = new RequisitionPartialWorkflowEndPoints();
	protected requisitionPartialWorkflowListColumns: RequisitionPartialWorkflowListColumns = new RequisitionPartialWorkflowListColumns();
	public requisitionPartialWorkflowForm: RequisitionPartialWorkflowForm = new RequisitionPartialWorkflowForm();
	public get name(): string { return this.requisitionPartialWorkflowListName };
	public get model(): models.RequisitionPartialWorkflowDTO { return this.requisitionPartialWorkflowListModel };
	public get endPoints(): IEntityEndPoints { return this.requisitionPartialWorkflowListEndPoints };
	public set endPoints(requisitionPartialWorkflowEndPoints: IEntityEndPoints) {
		this.requisitionPartialWorkflowListEndPoints = requisitionPartialWorkflowEndPoints;
		this.requisitionPartialWorkflowForm.endPoints = this.endPoints;
	};
	public get dataEndPoint(): IDataEndPoint { return this.endPoints.list };
	public get columns(): RequisitionPartialWorkflowListColumns { return this.requisitionPartialWorkflowListColumns };
}

export class RequisitionPartialWorkflowEntity implements IEntityOptions {
	protected requisitionPartialWorkflowEntityName: string = "requisitionPartialWorkflowEntity";
	protected requisitionPartialWorkflowEntityModel: models.RequisitionPartialWorkflowDTO = new models.RequisitionPartialWorkflowDTO();
	protected requisitionPartialWorkflowEntityEndPoints: RequisitionPartialWorkflowEndPoints = new RequisitionPartialWorkflowEndPoints();
	protected requisitionPartialWorkflowEntityList: RequisitionPartialWorkflowList = new RequisitionPartialWorkflowList();
	public get name(): string { return this.requisitionPartialWorkflowEntityName };
	public get model(): models.RequisitionPartialWorkflowDTO { return this.requisitionPartialWorkflowEntityModel };
	public get endPoints(): IEntityEndPoints { return this.requisitionPartialWorkflowEntityEndPoints };
	public set endPoints(requisitionPartialWorkflowEndPoints: IEntityEndPoints) {
		this.requisitionPartialWorkflowEntityEndPoints = requisitionPartialWorkflowEndPoints;
		this.grid.endPoints = this.endPoints;
	};
	public get grid(): RequisitionPartialWorkflowList { return this.requisitionPartialWorkflowEntityList };
	public get form(): RequisitionPartialWorkflowForm { return this.grid.requisitionPartialWorkflowForm };
	constructor(name?: string) {
		if (name) this.requisitionPartialWorkflowEntityName = name;
		this.endPoints = this.requisitionPartialWorkflowEntityEndPoints;
	}
};
//export class RequisitionPartialWorkflowGeneratedForm extends MfGeneratedFormComponent {
 // protected detailPageComponentForm: RequisitionPartialWorkflowForm = new RequisitionPartialWorkflowForm();
//};

//export class RequisitionPartialWorkflowListPageComponent extends ListPageComponent {
  //protected listPageComponentList: RequisitionPartialWorkflowList = new  RequisitionPartialWorkflowList();
  //protected showFilterColOnTable: boolean = true;
//};

